import { styled } from 'parkdepot-shared/theme'

export const VoucherContainer = styled<'div', { $loading: boolean }>('div', ({ $theme, $loading }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale700,
    transition: 'opacity 0.2s ease-in-out',

    ...($loading ? { opacity: 0.1, pointerEvents: 'none' } : {})
}))

export const VoucherTitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    margin: 0
}))

export const VoucherSubtitle = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0
}))

export const OverlayContainer = styled<'div', { $appearence: boolean }>('div', ({ $theme, $appearence }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transition: 'opacity 0.3s ease-in-out',

    ...($appearence ? { opacity: 1 } : { opacity: 0, visibility: 'hidden' })
}))
